
import Lastmenu2 from './LastMenu2';
import you from '../images/boy.png';
import bot from '../images/happy.png';
import { useState } from 'react';
const Careers = () =>{
    const [time] =useState(new Date());
    return(
        <>
        <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            You {time?.toLocaleTimeString()}</div>
          <div className="you-message">
            <div className="frame2 animated-frame"><b>Careers</b></div>
          </div>

          <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
          </div>
        <div className="frame1 animated-frame" >
            
            {/* <div className="box1" style={{marginLeft: '32px'}}> */}
                Explore Our Opportunities &nbsp;
                <a href='https://dodladairy.com/careers/'>Click Here</a>
            </div>
        {/* </div> */}
        <Lastmenu2 />
        </>
    );
}

export default Careers;